/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import moment from 'moment';

const useUpdateChart = ({ setRequestParams, start, end, interval }) => {

    const updateChart = useCallback(() => {
        setRequestParams({ start, end, interval });
    }, [setRequestParams, start, end, interval]);

    useEffect(() => {
        if (moment(start).toDate().toDateString() !== "Invalid Date" && moment(end).toDate().toDateString() !== "Invalid Date") {
            updateChart();
        }

    }, [start, end, interval]);

    return { updateChart };
};

export default useUpdateChart;